import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import {Button, IconButton, Popup, P, H3, S2, Panel, ListItem, Card, H5} from '../../../../components/UI/index.js'
import {formSpacing, FormStack, Input, Toggle} from '../../../../components/UI/forms/index.js'
import SensorModal from '../../../../components/resellers/SensorModal.js'

class Connections extends Reflux.Component {
    onChangeChecked(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.checked)

        this.props.onChange(reseller, path)
    }

    onChangeValue(path, event) {
        const reseller = {...this.props.reseller}

        reseller.settings.orders = reseller.settings.orders || {}

        _.set(reseller.settings, path, event.target.value)

        this.props.onChange(reseller)
    }

    onSaveValue(path, event) {
        const reseller = {...this.props.reseller}

        if (event) {
            _.set(reseller.settings, path, event.target.value)
        }

        this.props.onChange(reseller, path)
    }

    onClickGenerateApiKey() {
        const {reseller, onChange} = this.props

        if (!reseller.settings.apiKey) {
            reseller.settings.apiKey = generateUUID()
            onChange(reseller, 'apiKey')
        } else {
            this.popup.open('Genereer nieuwe API key', 'De oude API key is hierna niet meer geldig, bestaande koppelingen werken hierdoor niet meer.', () => {
                this.popup.close()
                reseller.settings.apiKey = generateUUID()
                onChange(reseller, 'apiKey')
            })
        }
    }

    onClickRemoveApiKey() {
        const {reseller, onChange} = this.props

        if (reseller.settings.apiKey) {
            this.popup.open('Verwijder API key', 'De API key wordt verwijderd, bestaande koppelingen werken hierdoor niet meer.', () => {
                this.popup.close()
                reseller.settings.apiKey = ''
                onChange(reseller, 'apiKey')
            })
        }
    }

    onUpdateSensor(sensor, index) {
        const reseller = {...this.props.reseller}

        if (typeof index === 'number') {
            reseller.settings.orders.sensors[index] = sensor
        } else {
            reseller.settings.orders.sensors = reseller.settings.orders.sensors || []
            reseller.settings.orders.sensors.push(sensor)
        }

        this.props.onChange(reseller, 'orders.sensors')
    }

    onRemoveSensor(index) {
        const reseller = {...this.props.reseller}

        reseller.settings.orders.sensors.splice(index, 1)

        this.props.onChange(reseller, 'orders.sensors')
    }

    render() {
        const {reseller} = this.props

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                <H3 style={{marginBottom: 36}}>Koppelingen</H3>

                <H5 style={{marginBottom: 24}}>API Key</H5>
                <P style={{marginBottom: 24}}>Om gebruik te maken van koppelingen is een API key vereist, deze kun je hieronder genereren. Deze API key is niet voor klanten en webshopkoppelingen. Hiervoor dient een API key in het klantaccount gegenereerd te worden.</P>

                <div style={{display: 'flex', alignItems: 'center', gap: formSpacing.tight, marginBottom: 12}}>
                    <Input
                        label='API Key'
                        readOnly
                        value={reseller.settings.apiKey || ''}
                    />
                    {!reseller.settings.apiKey &&
                        <Button style={{marginLeft: 6}} onClick={this.onClickGenerateApiKey.bind(this)}>Genereer API key</Button>
                    }
                    {reseller.settings.apiKey &&
                        <IconButton onClick={this.onClickGenerateApiKey.bind(this)}><i className='mdi mdi-refresh' /></IconButton>
                    }
                    {reseller.settings.apiKey &&
                        <IconButton onClick={this.onClickRemoveApiKey.bind(this)}><i className='mdi mdi-delete' /></IconButton>
                    }
                </div>

                <H5 style={{marginBottom: 24, marginTop: 24}}>Sense Anywhere</H5>
                <P style={{marginBottom: 24}}>Koppeling voor het monitoren van temperatuur tijdens het transport.</P>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Toggle
                        label='Actief'
                        checked={reseller.settings.orders.monitorTemperature}
                        onChange={this.onChangeChecked.bind(this, 'orders.monitorTemperature')}
                    />
                </FormStack>

                {reseller.settings.orders.monitorTemperature &&
                    <>
                        {reseller.settings.orders?.sensors?.length > 0 &&
                            <Panel style={{maxHeight: 500, overflowY: 'auto', marginBottom: 24}}>
                                {(reseller.settings.orders.sensors || []).map((sensor, index) => {
                                    return (
                                        <ListItem key={`sensor${index}`} onClick={() => this.sensorModal.open(sensor, index)}>
                                            <div>
                                                <P>{sensor.name}</P>
                                                <S2>{sensor.sensorId}</S2>
                                            </div>
                                        </ListItem>
                                    )
                                })}
                            </Panel>
                        }

                        <Button
                            variant='outline'
                            icon='mdi mdi-plus'
                            label='Nieuwe sensor'
                            onClick={() => this.sensorModal.open()}
                        />
                    </>
                }

                <SensorModal
                    onSubmit={this.onUpdateSensor.bind(this)}
                    onRemove={this.onRemoveSensor.bind(this)}
                    ref={(ref) => this.sensorModal = ref}
                />

                <Popup ref={(ref) => this.popup = ref} />
            </Card>
        )
    }
}

function generateUUID() {
    let d = new Date().getTime()

    if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
    }

    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })

    return uuid
}

export default (Connections)
